module.exports = __webpack_public_path__ + "static/media/L3_1.b04e4c87.gif";